{
  "about_thing": "A thing is anything you want: something to buy, somewhere to go, something to learn or try.",
  "about_what": "TingThings is where you keep the things you want to get, do or achieve, and share them with your friends and family.",
  "add_item_to_list": "Add an item to {title}",
  "app_name": "TingThings",
  "cancel": "Cancel",
  "close": "Close",
  "coming_up": "Coming Up",
  "error": "Error",
  "items_count": {
    "one": "{count} item",
    "other": "{count} items"
  },
  "loading": "Loading…",
  "nav_home": "Home",
  "nav_me": "Me",
  "nav_my_things": "My Things",
  "nav_their_things": "Their Things",
  "no_account": "No account yet?",
  "primary_navigation": "Primary",
  "private": "Private",
  "refresh": "Refresh",
  "return_to_sign_in": "Return to sign in",
  "shared": "Shared",
  "sign_in": "Sign in",
  "sign_out": "Sign out",
  "sign_up": "Sign up",
  "signed_in_as": "Signed in as {email}",
  "signing_out": "Signing out…",
  "tagline": "Cheers to the things you want",
  "working": "Working…"
}
